<template>
    <div>
      <v-dialog v-model="userGlobalCard">
        <user-card
          v-if="!loaded"
          @closeUserDialog="userGlobalCard=false"
          @reloadParent="reload_parent($event)"
        />
      </v-dialog>
    </div>
  </template>
  
  
  <script>
  import { mapActions, mapMutations, mapGetters } from 'vuex'
  import UserCard from './modalCard/userCard.vue';

    export default {
      props: {
      },

      data: () => ({
        loaded: false,
        userGlobalCard: false,
        profile_id: null,
        need_reload_parent: false,
      }),

      components:{
        UserCard,
      },

      methods:{  
        ...mapMutations([
          'UPDATE_OVERLAY',
        ]),
        ...mapActions([
          'CLOSE_USER_CARD',
          'GET_USER_ALL',
        ]),

        reload_parent(){
          this.need_reload_parent = true  // перезагрузка только вызвавшего карточку элемента
        },


        async open_modal_card() {
          this.UPDATE_OVERLAY(true)
          this.loaded = true
          this.need_reload_parent = false

          this.GET_USER_ALL(this.profile_id)
            .then(() => {
              this.UPDATE_OVERLAY(false)
              this.loaded = false
              this.userGlobalCard = true
            })
        },
      },

      computed: {
        ...mapGetters([
          'GETTERS_CURRENT_PROFILE_ID',
          'GETTERS_SHOW_USER_CARD',
        ]),
      },

      watch: {
        userGlobalCard(val){
          if(!val){
            this.CLOSE_USER_CARD({
              need_reload_parent: this.need_reload_parent,
            })
          }
        },

        GETTERS_SHOW_USER_CARD(val) {
        if (val) {
          this.profile_id = this.GETTERS_CURRENT_PROFILE_ID
          this.open_modal_card()
        }
      },
    }
    }
  </script>
  
  
